import { Form, Input, InputNumber, Modal, Radio, Space, Switch, message } from "antd";
import { buildProjectTypeCreatePayload, buildProjectTypeUpdatePayload } from "features/ProjectType/data/apiAdapters";
import { useCreateProjectType, useUpdateProjectType } from "features/ProjectType/data/hooks";
import { mapProjectType } from "features/ProjectType/data/mappers";
import { ProjectTypeState, confirmHide, setFormApiErrors } from "./ProjectTypeState";
import "features/ProjectType/presentation/pages/ProjectTypeList/index.scss";
export default function ProjectTypeFormModal({ current, onClose, onSaved }) {
  const [form] = Form.useForm();
  const create = useCreateProjectType();
  const update = useUpdateProjectType();
  const mutation = current ? update : create;
  const save = async (values) => {
    const submit = async () => {
      try {
        const record = current
          ? await update.mutate(current.id, buildProjectTypeUpdatePayload(values, current))
          : await create.mutate(buildProjectTypeCreatePayload(values));
        message.success(current ? "Đã cập nhật loại dự án" : "Đã thêm loại dự án");
        await onSaved(record);
        onClose();
      } catch (error) {
        setFormApiErrors(form, error);
      }
    };
    if (current?.isVisible && !values.isVisible) confirmHide(submit);
    else await submit();
  };
  if (mutation.error?.code === "FORBIDDEN") return <ProjectTypeState error={mutation.error} />;
  return (
    <Modal
      visible
      className="project-type-modal"
      width={580}
      title={current ? "Chỉnh sửa loại dự án" : "Thêm mới loại dự án"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={current ? "Lưu thay đổi" : "Lưu"}
      cancelText="Hủy"
      confirmLoading={mutation.loading}
      cancelButtonProps={{ disabled: mutation.loading }}
      closable={!mutation.loading}
      maskClosable={!mutation.loading}
    >
      <Form form={form} layout="vertical" initialValues={current || { displayPlace: "CARD" }} onFinish={save}>
        <Form.Item
          name="name"
          label="Tên loại dự án"
          rules={[
            { required: true, whitespace: true, message: "Vui lòng nhập tên loại dự án" },
            { max: 100, message: "Tên tối đa 100 ký tự" },
          ]}
        >
          <Input placeholder="Ví dụ: Hệ thống mạng" />
        </Form.Item>
        <Form.Item name="shortDescription" label="Mô tả ngắn" rules={[{ max: 500, message: "Mô tả tối đa 500 ký tự" }]}>
          <Input.TextArea rows={3} />
        </Form.Item>
        <Form.Item
          name="displayOrder"
          label="Thứ tự hiển thị"
          rules={[
            { required: Boolean(current), message: "Vui lòng nhập thứ tự hiển thị" },
            { type: "integer", min: 0, message: "Thứ tự phải là số nguyên ≥0" },
          ]}
        >
          <InputNumber style={{ width: "100%" }} />
        </Form.Item>
        {current && (
          <Form.Item name="isVisible" label="Hiển thị trên app" valuePropName="checked">
            <Switch />
          </Form.Item>
        )}
        <Form.Item name="displayPlace" label="Hiển thị trên app tại" rules={[{ required: true }]}>
          <Radio.Group>
            <Space direction="vertical">
              <Radio value="CARD">Thẻ riêng trên form</Radio>
              <Radio value="OTHER">Trong mục Khác</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, next) => prev.displayPlace !== next.displayPlace}>
          {() =>
            form.getFieldValue("displayPlace") === "OTHER" && <p>Loại không có thẻ riêng, khách chọn qua ô Khác</p>
          }
        </Form.Item>
        {current && (
          <p>
            Cập nhật lần cuối {mapProjectType(current).updatedAtLabel} · {mapProjectType(current).updatedByLabel}
          </p>
        )}
      </Form>
    </Modal>
  );
}
